"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackFemalePicker = void 0;
const react_1 = __importDefault(require("react"));
const FemaleClipPath_1 = __importDefault(require("./FemaleClipPath"));
const BackFemaleBodyParts_1 = __importDefault(require("./BackFemaleBodyParts"));
const BackFemalePicker = (props) => (react_1.default.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 620 1370", xmlSpace: "preserve", "data-testid": "backFemaleBodyPartPicker" },
    react_1.default.createElement("defs", null,
        react_1.default.createElement(FemaleClipPath_1.default, { x: "0", clipId: "female-clip" })),
    react_1.default.createElement(BackFemaleBodyParts_1.default, Object.assign({ clipPathId: "female-clip" }, props))));
exports.BackFemalePicker = BackFemalePicker;
exports.default = BackFemalePicker;
//# sourceMappingURL=BackFemalePicker.js.map